import React, { useContext } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
  FormControlLabel,
  IconButton,
  InputAdornment,
  FormHelperText,
} from '@material-ui/core';
import { BUTTON_TEXT } from 'global-constants/constants';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { Link } from 'react-router-dom';

import { Context } from 'context';
import { getCurrentYear } from 'utils';
import styles from './LoginRightPanel.module.scss';

const EmailLogin = (props) => {
  const {
    state: {
      domainConfig: { logo, logoAlt, showPoweredBy },
    },
  } = useContext(Context);

  const {
    showPassword,
    values,
    handleChange,
    setShowPassword,
    loading,
    buttonText,
    isRemember,
    handleLogin,
    formSubmitError,
  } = props;

  return (
    <div className={clsx(styles.rightContainer, { ['disable-form']: loading })}>
      <div className={styles.innerContainer}>
        <img className={styles.logoImage} src={logo} alt={logoAlt} />
        <Typography className={styles.headingH2} variant="h2">
          {BUTTON_TEXT.login}
        </Typography>
        <Typography className={styles.subHeading} variant="body1">
          Enter your credentials to get started.
        </Typography>

        <form className={styles.formContainer} onSubmit={handleLogin}>
          <TextField
            fullWidth
            id="email-input"
            value={values?.mobile}
            className={styles.formInputContainer}
            name="username"
            label="Username"
            variant="outlined"
            onChange={handleChange('mobile')}
            inputProps={{
              'data-testid': 'email-login-input',
            }}
          />

          <TextField
            fullWidth
            name="password"
            label="Enter Password"
            variant="outlined"
            className={styles.formInputContainerWithSubBtn}
            onChange={handleChange('password')}
            type={showPassword ? 'text' : 'password'}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    data-testid="toggle-view-button"
                  >
                    {!showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            inputProps={{
              autocomplete: 'new-password',
              'data-testid': 'new-password-input',
            }}
          />

          <div
            className={clsx(
              styles.formInputContainer,
              styles.rememberContainer,
              styles.justifyFlexEnd,
            )}
          >
            <Typography
              variant="body1"
              className={styles.rememberLinkContainer}
              style={{ cursor: 'pointer' }}
            >
              <Link
                className={styles.rememberLink}
                to="/forgot-password"
                data-testid="forgot-password-link"
              >
                {' '}
                Forgot Password?{' '}
              </Link>
            </Typography>
          </div>

          <div className={styles.loginBtnContainer}>
            {formSubmitError && (
              <FormHelperText className={clsx('color_error', styles.formError)}>
                <Typography variant="body1">{formSubmitError}</Typography>
              </FormHelperText>
            )}
            <Button
              fullWidth
              disabled={loading || !values.password || !values.mobile}
              variant="contained"
              color="secondary"
              onClick={handleLogin}
              type="submit"
              data-testid="email-login-submit"
            >
              {loading ? (
                <CircularProgress size={25} style={{ color: 'white' }} />
              ) : (
                buttonText
              )}
            </Button>
          </div>
        </form>

        {showPoweredBy && (
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            className="mg_top_100"
          >
            <Grid item>
              <img src={'/images/poweredByLogo.svg'} alt={logoAlt} />
            </Grid>

            <Grid item>
              <Typography
                variant="caption"
                className={styles.rememberLinkContainer}
              >
                &copy;{getCurrentYear()} &nbsp; &#9679; &nbsp; Subscribili
                &nbsp; &#9679; &nbsp; All Rights Reserved
              </Typography>
            </Grid>
          </Grid>
        )}
      </div>
    </div>
  );
};

EmailLogin.propTypes = {
  showPassword: PropTypes.bool,
  values: PropTypes.object,
  handleChange: PropTypes.func,
  setShowPassword: PropTypes.func,
  setRemember: PropTypes.func,
  loading: PropTypes.bool,
  buttonText: PropTypes.string,
  isRemember: PropTypes.bool,
  handleLogin: PropTypes.func,
  formSubmitError: PropTypes.string,
};

export default EmailLogin;
